export class NoopAppletStateRegistrar {
    get appletCount() { return null; }
    createStateId() { }
    getStateCounts() { }
    register() { }
    setState() { }
}